<template>
  <div class="mainbox">
    <img class="logo" :src="require('../assets/logo6.png')" alt="" />
    <a-form-model :model="form" style="width:400px" layout="vertical">
      <a-form-model-item label="账号" prop="mobile">
        <a-input
          @keydown.enter="submitForm"
          v-model="form.mobile"
          type="text"
          autocomplete="off"
        />
      </a-form-model-item>
      <a-form-model-item label="密码" prop="password">
        <a-input
          @keydown.enter="submitForm"
          v-model="form.password"
          type="password"
          autocomplete="off"
        />
      </a-form-model-item>
      <a-button type="primary" block @click="submitForm()">
        登录
      </a-button>
    </a-form-model>
    <div @click="wxlogin" class="other">
      <img src="../assets/wx.png" alt="" />
      <div class="name">微信登录</div>
    </div>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      centered
      @cancel="previewVisible = false"
      width="360px"
    >
      <div style="padding:20px">
        <img alt="example" style="width: 100%" :src="previewImage" />
        <div class="tip">微信扫一扫登录</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import qs from "qs";
import Cookies from "js-cookie";
import { EventBus } from "../utils/eventBus";
export default {
  name: "HelloWorld",
  data() {
    return {
      form: {
        mobile: "",
        password: "",
      },
      previewVisible: false,
      previewImage: require("../assets/ewm.jpg"),
    };
  },
  methods: {
    wxlogin() {
      window.location.href =
        "https://open.weixin.qq.com/connect/qrconnect?appid=wxade2c2629e9c9347&redirect_uri=https://www.guanmini.com/api/Login/scanLogin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
    },
    submitForm() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.login,
        data: qs.stringify(this.form),
      })
        .then((res) => {
          if (res.data.status != '200') {
            this.$message.error(res.data.msg);
            return false;
          }
          console.log(res);
          this.$store.dispatch("setUserInfo", res.data.data);
          this.$store.dispatch("setHeader", res.data.token);
          if (!res.data.data.is_teacher) {
            this.$message.error("您不是教师");
            setTimeout(() => {
              if (this.$route.path != "/login") {
                this.$router.push({ path: "/login" });
              }
            }, 200);
            return false;
          }
          if (res.data.status == 200) {
            this.$axios({
              method: "POST",
              url: this.$api.domain + this.$api.teacherInfo,
              headers: {
                Authorization: res.data.token,
              },
              data: qs.stringify(this.form),
            })
              .then((teahcherInfo) => {
                if (teahcherInfo.data.status == 200) {
                  Cookies.set("loginform", this.form, { expires: 7 });
                  this.$message.success("登录成功！");
                  setTimeout(() => {
                    this.$router.push({ path: "/createStudent" });
                  }, 800);
                  EventBus.$emit("getFonts", true);
                } else {
                  this.$message.error(teahcherInfo.data.msg);
                }
              })
              .catch(() => {
                this.$message.error("登录失败，服务或者网络错误");
              });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$message.error("登录失败，服务或者网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tip {
  text-align: center;
  color: #999;
  font-size: 12px;
}
.other {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  color: #898989;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
  }
}
.mainbox {
  width: 1000px;
  height: 600px;
  border-radius: 12px;
  background: #ffffff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 80px;
  box-sizing: border-box;
}
.logo {
  width: 200px;
  margin-top: 20px;
  margin-bottom: 60px;
}
::v-deep .ant-btn-primary {
  color: #fff;
  background-color: #67b0dc;
  border-color: #67b0dc;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
